import app from 'flarum/forum/app';
import Group from 'flarum/common/models/Group';
import MentionableModel from './MentionableModel';
import Badge from 'flarum/common/components/Badge';
import highlight from 'flarum/common/helpers/highlight';
export default class GroupMention extends MentionableModel {
  type() {
    return 'group';
  }
  initialResults() {
    return Array.from(app.store.all('groups').filter(g => {
      return g.id() !== Group.GUEST_ID && g.id() !== Group.MEMBER_ID;
    }));
  }

  /**
   * Generates the mention syntax for a group mention.
   *
   * @"Name Plural"#gGroupID
   *
   * @example <caption>Group mention</caption>
   * // '@"Mods"#g4'
   * forGroup(group) // Group display name is 'Mods', group ID is 4
   */
  replacement(group) {
    return this.format.format(group.namePlural(), 'g', group.id());
  }
  suggestion(model, typed) {
    let groupName = model.namePlural();
    if (typed) {
      groupName = highlight(groupName, typed);
    }
    return m('[', null, m(Badge, {
      className: `Avatar Badge Badge--group--${model.id()} Badge-icon`,
      color: model.color(),
      type: "group",
      icon: model.icon()
    }), m("span", {
      className: "username"
    }, groupName));
  }
  matches(model, typed) {
    if (!typed) return false;
    const names = [model.namePlural().toLowerCase(), model.nameSingular().toLowerCase()];
    return names.some(name => name.toLowerCase().substr(0, typed.length) === typed);
  }
  maxStoreMatchedResults() {
    return null;
  }

  /**
   * All groups are already loaded, so we don't need to search for them.
   */
  search(typed) {
    return Promise.resolve([]);
  }
  enabled() {
    return app.session?.user?.canMentionGroups() ?? false;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/GroupMention', GroupMention);